import { render, staticRenderFns } from "./ViewCoutUserSentSmsHistoryFail.vue?vue&type=template&id=2b4ca29a&scoped=true"
import script from "./ViewCoutUserSentSmsHistoryFail.vue?vue&type=script&lang=js"
export * from "./ViewCoutUserSentSmsHistoryFail.vue?vue&type=script&lang=js"
import style0 from "./ViewCoutUserSentSmsHistoryFail.vue?vue&type=style&index=0&id=2b4ca29a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4ca29a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b4ca29a')) {
      api.createRecord('2b4ca29a', component.options)
    } else {
      api.reload('2b4ca29a', component.options)
    }
    module.hot.accept("./ViewCoutUserSentSmsHistoryFail.vue?vue&type=template&id=2b4ca29a&scoped=true", function () {
      api.rerender('2b4ca29a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifihistory/ViewCoutUserSentSmsHistoryFail.vue"
export default component.exports